import { useEffect, useState } from "react";
import { hostedSession } from "../lib/hosted";

/** The signed-in GitHub login, so a row can say "you" instead of "@someone". */
export function useViewerLogin(): string | undefined {
  const [login, setLogin] = useState<string>();
  useEffect(() => {
    let cancelled = false;
    void hostedSession()
      .then((session) => { if (!cancelled) setLogin(session.user.login); })
      .catch(() => undefined);
    return () => { cancelled = true; };
  }, []);
  return login;
}
